export default __webpack_public_path__ + "static/media/patent_automatic.4d726aae.jpg";